import React from "react";

// OPTION 3 — "Bold Monogram Block"
// A modern powerhouse mark: a solid rounded square block with an integrated
// globe + interlocked WWD, and a heavy stacked wordmark. Confident and scalable.
export default function LogoOption3({ variant = "dark", size = 52 }) {
  const navy = "#1b2545";
  const teal = "#2fb89c";
  const textMain = variant === "light" ? "#ffffff" : navy;

  return (
    <div className="flex items-center gap-3 select-none">
      <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
        <rect x="2" y="2" width="60" height="60" rx="16" fill={navy} />
        {/* corner accent */}
        <path d="M46 2 H62 V18 Z" fill={teal} opacity="0.9" />
        {/* globe */}
        <circle cx="32" cy="30" r="16" stroke={teal} strokeWidth="2.4" fill="none" />
        <ellipse cx="32" cy="30" rx="6.5" ry="16" stroke={teal} strokeWidth="1.8" fill="none" opacity="0.8" />
        <line x1="16" y1="30" x2="48" y2="30" stroke={teal} strokeWidth="1.8" opacity="0.8" />
        <line x1="19" y1="22" x2="45" y2="22" stroke={teal} strokeWidth="1.4" opacity="0.6" />
        <line x1="19" y1="38" x2="45" y2="38" stroke={teal} strokeWidth="1.4" opacity="0.6" />
        {/* bold W */}
        <text x="32" y="37" textAnchor="middle" fontFamily="Sora, sans-serif" fontWeight="800" fontSize="20" fill="#ffffff">W</text>
      </svg>
      <div className="leading-none">
        <div style={{ fontFamily: "Sora, sans-serif", fontWeight: 800, fontSize: 17, color: teal, letterSpacing: "0.5px", lineHeight: 1.1 }}>
          WORLD&nbsp;WIDE
        </div>
        <div style={{ fontFamily: "Sora, sans-serif", fontWeight: 800, fontSize: 17, color: textMain, letterSpacing: "0.5px", lineHeight: 1.1 }}>
          WHOLESALE
        </div>
        <div style={{ fontFamily: "Sora, sans-serif", fontWeight: 800, fontSize: 17, color: textMain, letterSpacing: "0.5px", lineHeight: 1.1 }}>
          DEALS <span style={{ fontSize: 10, color: teal, verticalAlign: "super" }}>LLC</span>
        </div>
      </div>
    </div>
  );
}
